export default {
  delta360_endpoint: "https://demo.delta360.mx/api/",
  // delta360_endpoint: 'http://unitsv8.test/api/',
};
